import React, { Component } from 'react';
import SummaryFlights from 'components/components/common/SummaryFlights';

class FlightDetailsContainer extends Component {
  render() {
    var camelCaseProps = {
      adultsNumber: this.props.adults,
      childrenNumber: this.props.children,
      studentsNumber: this.props.students,
      departureAddress: { phrase: this.props.address_phrase, selectedObject: {value: this.props.address_details.name } },
      returnAddress: { phrase: null },
      departureFlight: this.props.flight,
      returnFlight: null,
      differentReturnAddress: false,
      price: this.props.price,
      paymentToDriver: this.props.payment_to_driver,
      locale: this.props.locale,
      flightType: this.props.reservation_direction
    }
    return (<SummaryFlights isDashboard {...camelCaseProps} />);
  }
}

export default FlightDetailsContainer;
